import { useRouter } from 'next/router';
import Link from 'next/link';
import { SiteInfoContext } from '@contexts/SiteInfoContext';
import { HeaderContext } from '@contexts/HeaderContext';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import SiteMapping from '../../configs/siteMapping';

const LanguageContainer = ({ layoutType }) => {
    const { t } = useTranslation();
    const router = useRouter();
    const { asPath, locale } = useRouter();
    const { languageList, siteName } = useContext(SiteInfoContext);
    const [state, dispatch] = useContext(HeaderContext);
    const [reSortLanguageList, setReSortLanguageList] = useState(languageList);
    useEffect(() => {
        const vnToFirstPlace = [SiteMapping.viva88, SiteMapping.bong88];
        if (vnToFirstPlace.includes(siteName)) {
            const newLanguageList = [...languageList];
            const index = newLanguageList.findIndex((language) => language.code === 'vn');
            if (index !== -1) {
                const [removed] = newLanguageList.splice(index, 1);
                newLanguageList.unshift(removed);
            }
            setReSortLanguageList(newLanguageList);
        }
    }, []);

    useEffect(() => {
        dispatch({ type: 'CHANGE_LANGUAGE', value: locale });
    }, [locale]);

    return (
        <div className="language-list">
            {
                layoutType === 'rightNav'
                    && (
                        <div className="language-list__header">
                            <span className="text">{t('lbl_Language')}</span>
                        </div>
                    )
            }
            {reSortLanguageList.map((item) => (
                <div
                    className="language-list__item"
                    data-selected={state.language === item.code}
                    key={item.code}
                >
                    <Link
                        className="btn"
                        href={router.pathname}
                        as={asPath}
                        locale={item.code}
                    >
                        <i className={`flag flag--${item.code}`} />
                        <span className="text">{item.name}</span>
                        <i className="icon icon--done" />
                    </Link>
                </div>
            ))}
        </div>
    );
};

export default LanguageContainer;
